import ModalContainer from './modal_container';

const Modal = ModalContainer;

export default Modal;
